module.exports = __webpack_public_path__ + "img/HuaweiP9Lite.5d9bcee4.png";